/**
 * @generated SignedSource<<fbb33b82490f39edc133cc8029a6e5d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DepartmentAvailabilitySidebarFragment_department$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DepartmentAvailabilityCoursePicker_department" | "DepartmentAvailabilityDatePicker_department" | "DepartmentAvailabilityGroupSizeSelect_department" | "DepartmentAvailabilityTimeSliderFragment_department" | "departmentToScheduleOption_department">;
  readonly " $fragmentType": "DepartmentAvailabilitySidebarFragment_department";
};
export type DepartmentAvailabilitySidebarFragment_department$key = {
  readonly " $data"?: DepartmentAvailabilitySidebarFragment_department$data;
  readonly " $fragmentSpreads": FragmentRefs<"DepartmentAvailabilitySidebarFragment_department">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DepartmentAvailabilitySidebarFragment_department",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DepartmentAvailabilityTimeSliderFragment_department"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DepartmentAvailabilityGroupSizeSelect_department"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "departmentToScheduleOption_department",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DepartmentAvailabilityDatePicker_department"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DepartmentAvailabilityCoursePicker_department"
    }
  ],
  "type": "Department",
  "abstractKey": null
};

(node as any).hash = "b0d464ff15f9518259b0cae5085a0d75";

export default node;
